/*
 * @Author: wlo_o
 * @Date: 2022-02-25 10:45:22
 * @LastEditors: wlo_o
 * @LastEditTime: 2022-03-18 17:03:38
 * @FilePath: /frontend/lib/mixins/FormMixin.js
 * @Description: 处理扩展字段的部分逻辑
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
 */
import { fetchApi } from '../common/apis'
import pick from 'lodash/pick'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

export default {
  props: {
    id: { type: [String, null], default: null }, // 集合主键
    title: { type: [String, null], default: '' },
    editable: { type: Boolean, default: true },
    showGoBack: { type: Boolean, default: false }, // 显示返回
    type: { type: [String, null], default: null },
    showSaveBtn: { type: Boolean, default: true },
    defaultData: { type: [Object, null], default: null } // 新增时的默认数据
  },
  computed: {
    showHeader: function () {
      return (!!this.$slots.title || this.title) && (this.editable && this.showSaveBtn)
    },
    extFormConfig: function () {
      return this.getExtFormConfig()
    }
  },
  data () {
    let defaultFormConfig = {
      readonly: !this.editable,
      isShowSubmitBtn: false,
      isShowBackBtn: false,
      labelWidth: 100
    }
    let formConfig = {
      ...defaultFormConfig,
      formDesc: {
        name: { type: 'input', label: '名称', required: true },
        code: { type: 'input',
          label: '编码',
          required: true,
          attrs: { readonly: true },
          vif: (data) => !!data.id
        },
        sourceCode: { type: 'text',
          label: '来源标识符',
          attrs: { readonly: true },
          vif: (data) => !!data.id,
          displayFormatter: (v) => !v ? '——————' : v
        },
        keyword: { type: 'input', label: '关键词' }
      },
      order: [ 'name', 'code', 'sourceCode', 'keyword' ]
    }
    let filterFormConfig = get(this, '$OecpMetaDataConfig.filterFormConfig') || function (params) { return params }
    formConfig = filterFormConfig(formConfig, this.type)
    return {
      loading: false,
      formData: {}, // 主表内容
      extData: {}, // 扩展表内容
      extList: [], // 扩展表内容，对应数据库内的水平格式，数据集在修改状态时这里会有值
      stateId: this.id,
      categoryIds: [], // 关联的分类id
      defaultFormConfig,
      formConfig
    }
  },
  methods: {
    getTypeConfigList () {
      return get(this.getMbOptionVar('typeConfig'), 'list') || []
    },
    getTypeConfig () {
      let { type } = this
      return this.getTypeConfigList().find(o => o.type === type)
    },
    getExtFormConfig () {
      let typeCfg = this.getTypeConfig()
      let { component = 'set' } = typeCfg
      let { type } = this
      let cfg = this.getMbOptionVar(`${component}FormExtConfig${type}`)
      cfg = cfg ? { ...this.defaultFormConfig, ...cfg } : cfg
      let filterFormConfig = get(this, '$OecpMetaDataConfig.filterFormExtConfig') || function (params) { return params }
      cfg = filterFormConfig(cfg, this.type)
      if (!this.editable) {
        for (let key in cfg.formDesc) {
          let item = cfg.formDesc[key]
          item.type === 'md-upload-file' && (item.attrs = { ...item.attrs, isCanDelete: false, disabled: true })
        }
      }
      return cfg
    },
    loadCategoryList () {
      let that = this
      let { stateId: id, type } = this
      fetchApi.call(this, '/category/findRelationship', { id, type }).then((res = []) => {
        that.categoryIds = res.reduce((arr, o) => [ ...arr, o.categoryId ], [])
      })
    },
    handleTagClick (categoryId, action) {
      let { stateId: id, type } = this
      let query = { id, categoryId, type }
      if (action === 'add') {
        fetchApi.call(this, '/category/addRelationship', query)
      } else if (action === 'remove') {
        fetchApi.call(this, '/category/delRelationship', query)
      }
    },
    // 扩展数据更新，将列表数据格式化成表单数据格式   { "extName": "definition", "extValue": "标识"} -> { "definition": "标识" }
    extArray2FormData (extList = [], extConfig = {}) {
      if (isEmpty(extConfig)) return []
      let keys = Object.keys(extConfig.formDesc)
      let counterKv = {}
      let extDataKv = extList.reduce((rs, o) => {
        if (keys.includes(o.extName)) {
          counterKv[o.extName] = (counterKv[o.extName] || 0) + 1
          return { ...rs, ...o.extName && { [o.extName]: o.extValue } }
        } else {
          return rs
        }
      }, {})
      let oops = []
      for (let key in counterKv) {
        counterKv[key] > 1 && oops.push(get(extConfig, `formDesc.${key}.label`) + `（${key}）`)
      }
      oops.length && this.$notify.error({
        title: '错误', // duration: 0,
        message: oops.join('、') + '出现重复值，请通知管理员进行维护！'
      })
      return pick(extDataKv, keys)
    },
    afterSaveFn () { // 处理部分扩展控件
      let { extFormConfig = {}, extData } = this
      let that = this
      if (!isEmpty(extFormConfig)) {
        let formDesc = get(extFormConfig, 'formDesc') || {}
        for (let field in formDesc) {
          let itemCfg = get(formDesc, field) || {}
          let { type } = itemCfg
          if (type === 'md-range-select') { // 需要保存后再更新
            let { rangeConfig: { parentId, saveNewLabel = false } } = itemCfg
            let label = extData[field]
            if (!saveNewLabel && !parentId && !label) break
            let query = { parentId, label, labelFuzzyQuery: false, page: 1, pageSize: 1 }
            fetchApi.call(that, '/element/values/pageList', query).then(function (res) {
              if (res.total > 0) return
              let saveData = { parentId, value: label, label: label, isSys: '0' }
              fetchApi.call(that, '/element/values/save', saveData)
            })
          }
        }
      }
    }
  }
}
